<template>
  <el-form-item
    :label="`${$t('TAG')}`"
    prop="company_vehicle_tags"
    v-loading="carTagsLoading"
    element-loading-spinner="el-icon-loading"
  >
    <el-select
      ref="tagSelect"
      :disabled="ruleForm.disabled"
      v-model="ruleForm.company_vehicle_tags"
      clearable
      @change="$emit('tags', ruleForm.company_vehicle_tags)"
      @clear="$emit('clear')"
      @blur="$emit('blur')"
      @visible-change="handleVisibleChange"
      multiple
      collapse-tags
      filterable
      :placeholder="$t('SELECT_PLACEHOLDER')"
      :no-data-text="$t('NO_RESULT')"
    >
      <el-option
        v-for="item in carTags"
        :key="item.id + Math.random()"
        :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
        :value="item.id"
      ></el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { getCarsTag } from '@/api/cars'
export default {
  props: ['value'],
  data() {
    return {
      ruleForm: {
        company_vehicle_tags: [],
      },

      carTags: [],
      carTagsLoading: true,
    }
  },

  mounted() {
    this.$nextTick(() => {
      const input = this.$refs.tagSelect && this.$refs.tagSelect.$refs.input
      if (!input) return
      this.searchInput = input
      input.addEventListener('input', this.onSearchInput)
    })
  },
  beforeDestroy() {
    if (this.searchInput) {
      this.searchInput.removeEventListener('input', this.onSearchInput)
    }
  },
  methods: {
    normalizeSearch(value) {
      if (value == null || value === '') return ''
      return this.toEnglish(value, false) || ''
    },
    onSearchInput(event) {
      const input = event.target
      const value = input.value
      if (!/[۰-۹]/.test(value)) return

      const normalized = this.normalizeSearch(value)
      if (normalized === value) return

      const start = input.selectionStart
      const end = input.selectionEnd
      input.value = normalized
      this.$refs.tagSelect.query = normalized
      if (start != null && end != null) {
        input.setSelectionRange(start, end)
      }
    },
    handleVisibleChange(visible) {
      // When dropdown closes (visible becomes false), emit blur event
      if (!visible) {
        this.$emit('blur')
      }
    },
  },

  created() {
    getCarsTag.api().then((res) => {
      if (res) {
        this.carTags = res.sort((a, b) => {
          const nameA = a.fa_title?.toLowerCase() || ''
          const nameB = b.fa_title?.toLowerCase() || ''
          return nameA.localeCompare(nameB)
        })
        this.carTagsLoading = false
      }
    })
  },
  watch: {
    value(val) {
      if (!val || !Array.isArray(val) || (val.length === 1 && val[0] === ''))
        return

      const numberArray = val.map(Number)

      this.ruleForm.company_vehicle_tags = numberArray
    },
  },
}
</script>
